import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {formatDateWithDay, formatDateShort} from 'lib/helpers/globalize-helper';

function SearchSummary({query, handleCollapse, translations}) {
  const {dep, arr, obDate, ibDate, isRoundtrip, passengersAdult, passengersChild, passengersInfant} = query;
  const {departure, returnTitle, onePassenger, manyPassengers, showSearchMask} = translations;
  const totalPax = parseInt(passengersAdult, 10) + parseInt(passengersChild, 10) + parseInt(passengersInfant, 10);

  return (
    <div>
      <a
        className="text-muted float-right mt-1"
        onClick={() => handleCollapse()}
      >
        <span className="text-small d-xs-none mr-2">{showSearchMask}</span>
        <i className="icon icon-down-arrow icon-sm"></i>
      </a>
      <h1 className="search-summary-title m-0">{dep.split('-')[0]}
        &nbsp;<i className="icon icon-16 icon-right-arrow"></i> {arr.split('-')[0]}&nbsp;
      </h1>
      <span className="d-xs-none">
        <b>{departure}</b>: {formatDateWithDay(obDate)}
        {isRoundtrip === '1' && <span> - <b>{returnTitle}</b>: {formatDateWithDay(ibDate)}</span>}
      </span>
      <span className="d-xs-inline d-sm-none">
        {formatDateShort(obDate)}
        {isRoundtrip === '1' && <span> - {formatDateShort(ibDate)}</span>}
      </span>
      , <span>
        {
          totalPax === 1 ? onePassenger : manyPassengers.replace('{number}', totalPax)
        }
      </span>
    </div>
  );
}

SearchSummary.propTypes = {
  query: PropTypes.shape({
    dep: PropTypes.string.isRequired,
    arr: PropTypes.string.isRequired,
    obDate: PropTypes.instanceOf(Date).isRequired,
    ibDate: PropTypes.instanceOf(Date).isRequired,
    isRoundtrip: PropTypes.string.isRequired,
    passengersAdult: PropTypes.string.isRequired,
    passengersChild: PropTypes.string.isRequired,
    passengersInfant: PropTypes.string.isRequired
  }),
  handleCollapse: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(SearchSummary);
